// extracted by mini-css-extract-plugin
export default {"content":"DateCell-module__content__Wa9FS","date":"DateCell-module__date__Ma-D-","label":"DateCell-module__label__9ZjL-"};